<template>
  <div class="bi-control-panel-tab">
    <BIApprovalFilter />
    <BIApprovalTable :can-edit="canEdit" />
  </div>
</template>
<script>
import BIApprovalFilter from '@/components/BIControlPanel/BIApprovalFilter.vue';
import BIApprovalTable from '@/components/BIControlPanel/BIApprovalTable.vue';

export default {
  name: 'BIApprovalTab',
  components: { BIApprovalFilter, BIApprovalTable },
  props: {
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
